import Vue from 'vue'
import VueRouter from 'vue-router'
import iView from 'iview'

import routes from './routes'

Vue.use(VueRouter)
Vue.use(iView)

const router = new VueRouter({
  mode: 'history',
  base: process.env.NODE_BASE_URL || '/',
  routes,
  linkActiveClass: 'active',
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

router.beforeEach((to, from, next) => {
  iView.LoadingBar.start()
  // 路由拦截
  // 参考：https://segmentfault.com/a/1190000008383094
  // if (to.meta.requiresAuth) {  // 判断该路由是否需要登录权限
  //   if (store.state.token) {  // 通过vuex state获取当前的token是否存在
  //     next();
  //   }
  //   else {
  //     next({
  //       path: '/login',
  //       query: {redirect: to.fullPath}  // 将跳转的路由path作为参数，登录成功后跳转到该路由
  //     })
  //   }
  // }
  // else {
  //   next();
  // }

  next()
})

router.afterEach(transition => {
  iView.LoadingBar.finish()
})

// 导出router对象
export default router
